module.exports = __webpack_public_path__ + "img/whoweare_mobile.37556982.png";